import React from 'react';
import PropTypes from 'prop-types';

import Highlighter from 'react-highlight-words';

// Parenthesis and other special characters used in advanced boolean
// searches don't play well with the hghlighter lib regex matching
const sanitise = (searchTerms) => {
  const sanitisedTerms = searchTerms.map(searchTerm => searchTerm.replace(/\(|\)|\\|\[|\*|\?/g, ''));
  return sanitisedTerms;
};

// Split phrases into tokens too for matching multiple keywords
// We'll likely move away from doing this and use Elastic Search
// highlighting so temporary logic for now.
const tokenise = (searchTerms) => {
  let tokenisedTerms = [];

  searchTerms.forEach((searchTerm) => {
    const tokens = searchTerm.split(' ');
    tokenisedTerms = [...tokenisedTerms, ...tokens];

    if (tokens.length > 1) {
      tokenisedTerms = [...tokenisedTerms, searchTerm];
    }
  });

  return tokenisedTerms;
};

const Highlight = ({ text, searchTerms, className }) => (
  <Highlighter
    searchWords={tokenise(sanitise(searchTerms))}
    textToHighlight={text}
    className={className}
  />
);

Highlight.propTypes = {
  text: PropTypes.string.isRequired,
  searchTerms: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
};

Highlight.defaultProps = {
  className: '',
};

export default Highlight;
